// extracted by mini-css-extract-plugin
export default {"container":"SignalNavigation_container__Ulaha","canvas":"SignalNavigation_canvas__ZP5B3"};